import { useState, useEffect } from 'react';

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!visible) return;
    const timer = setInterval(() => {
      setPulse(true);
      setTimeout(() => setPulse(false), 600);
    }, 6000);
    return () => clearInterval(timer);
  }, [visible]);

  return (
    <div
      className={`fixed bottom-8 right-8 z-50 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6 pointer-events-none'
      }`}
    >
      <a
        href="#contact"
        className={`flex items-center gap-2.5 bg-texas-red hover:bg-texas-red-dark text-white text-sm font-semibold px-5 py-3.5 rounded-full cursor-pointer whitespace-nowrap transition-all duration-200 ${
          pulse ? 'scale-105' : 'scale-100'
        }`}
        style={{ boxShadow: '0 4px 24px rgba(191,10,48,0.35)' }}
      >
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-calendar-check-line text-base" />
        </div>
        Schedule a Consultation
      </a>
    </div>
  );
}
